// extracted by mini-css-extract-plugin
export default {"table":"styles_table__fQLO5"};